import { WindowManager } from '@citrite/workspace-ui-platform';
import { environment } from 'Environment';

export const windowManager: WindowManager = {
	openWindow: (...args) => environment.openWindow(...args),
	closeWindow: (...args) => environment.closeWindow(...args),
	isWindowClosed: (...args) => environment.isWindowClosed(...args),
	focusWindow: (...args) => environment.focusWindow(...args),
};
